import * as constants from "../../assets/constants";
import {baseApi} from "../BaseApi";



class SalePointsApi extends baseApi {

    getOne = async (id) => {

        return await this.get(`?app=salePoints&act=getOne&id=${id}`)

    }
    autocomplete = async (search, limit = 15) => {
        return await this.get(`?app=salePoints&act=autocomplete&search=${encodeURIComponent(search)}&limit=${limit}`)
    }
    getListMalls = async (data) => {

        return await this.post('?app=salePoints&act=getList', data)

    }

    getListWithMonitoring = async (data) => {

        return await this.post('?app=salePoints&act=getListWithMonitoring', data)

    }
    saveSalePoint = async (data) => {
        return await this.post('?app=salePoints&act=save', {data:JSON.stringify(data)})

    }
    getAllSalePoints = async (data) => {
        return await this.post('?app=salePoints&act=getAll', data)

    }
    getAllCities = async (data) => {
        return await this.post('?app=salePoints&act=getAllCities', data)

    }

    deleteSalePoint = async (id) => {
        return await this.post('?app=salePoints&act=setDeleted', {id})

    }

    closeSalePoint = async (id) => {
        return await this.post('?app=salePoints&act=close', {id})
    }

    openSalePoint = async (id) => {
        return await this.post('?app=salePoints&act=open', {id})
    }

    getMonitoringGalleries = async (sp_id) => {
        return await this.get(`?app=salePoints&act=getMonitoringGalleries&sp_id=${sp_id}`)
    }

    getReportUrl = (date) => {
        const dateStr = date instanceof Date ? date.toLocaleDateString() : date
        return `${this.base_url}?app=salePoints&act=report&date=${dateStr}`
    }

    getDataLensExportUrl = (dateFrom, dateTo) => {
        const from = dateFrom instanceof Date ? dateFrom.toLocaleDateString('ru-RU') : dateFrom
        const to = dateTo instanceof Date ? dateTo.toLocaleDateString('ru-RU') : dateTo
        return `${this.base_url}?app=salepoints&act=fullExportYandexDataLensXLSX&date_from=${from}&date_to=${to}`
    }
}

export default new SalePointsApi(constants.DEBUG?constants.base_url_stage:constants.base_url_prod);